const { host } = window.location;

export const baseUrl = host.startsWith("trace.") ? host.substring(6) : host;

const isDevelopment = process.env.NODE_ENV === "development";

const buildUrl = (relativeUrl, subdomain) => {
  const prefix = isDevelopment || !subdomain ? "" : `${subdomain}.`;
  return `//${prefix}${baseUrl}${relativeUrl || ""}`;
};

export const getMainUrl = relativeUrl => buildUrl(relativeUrl);

export const getLoadsUrl = relativeUrl => buildUrl(relativeUrl, "loads");

export const getIdUrl = relativeUrl => buildUrl(relativeUrl, "id");

export const getApiUrl = relativeUrl => buildUrl(relativeUrl, "api");

export const getAboutUrl = relativeUrl => buildUrl(relativeUrl, "about");

export const getTrucksUrl = relativeUrl => buildUrl(relativeUrl, "trucks");

export const getSecondLevelDomain = () => {
  const { hostname } = window.location;

  // Разбиваем hostname на части по точкам
  const parts = hostname.split(".");

  // Для случаев типа "my-site.net" (домен второго уровня)
  if (parts.length === 2) {
    return hostname;
  }

  // Для случаев типа "trace.my-site.net" (поддомен + домен второго уровня)
  if (parts.length > 2) {
    return parts.slice(-2).join(".");
  }

  // Возвращаем hostname как есть, если он не соответствует ожидаемым форматам (например, localhost)
  return hostname;
};
